export const testConstant = {
  GET_TEST_TYPES: "GET_TEST_TYPES",
  GET_ADMIN_TEST_TYPES: "GET_ADMIN_TEST_TYPES",
  GET_TEST_TYPES_CHARTs: "GET_TEST_TYPES_CHARTs",
  ADD_TEST_TYPES: "ADD_TEST_TYPES",
  UPDATE_TEST_TYPES: "UPDATE_TEST_TYPES",
  DELETE_TEST: "DELETE_TEST",
  DELETE_TEST_TYPES: "DELETE_TEST_TYPES",
  GET_FORM_FIELDS: "GET_FORM_FIELDS",
  GET_TEST_TYPES_CHART: "GET_TEST_TYPES_CHART",
};
